/*
 * Reveals the product images held back beyond the first six.
 *
 * The grid renders every image; those past the sixth carry
 * .product__media-item--overflow and are hidden by CSS until the grid gets
 * .is-expanded. Keeping them in the DOM means the lightbox and variant image
 * matching continue to see the full set.
 */
(function () {
  function bind(button) {
    if (button.dataset.viewMoreBound === 'true') return;
    button.dataset.viewMoreBound = 'true';

    button.addEventListener('click', function () {
      var grid = button.parentElement.querySelector('.product__media-grid');
      if (!grid) return;
      grid.classList.add('is-expanded');
      button.setAttribute('aria-expanded', 'true');
      button.hidden = true;
    });
  }

  function init(root) {
    (root || document).querySelectorAll('[data-media-view-more]').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // Section re-renders (variant changes, theme editor) replace the markup.
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
